"use client";

import { c as _c } from "react/compiler-runtime";
import { Dropdown } from "@opensea/next-ui-kit";
import { DropdownSeparator, useToasts } from "@opensea/ui-kit";
import { SwapHoriz } from "@opensea/ui-kit/icons";
import { AccountNotConnectedError, useConnect, useConnections, useDisconnect, WalletRejectedError } from "@opensea/wallet";
import { captureException } from "@sentry/nextjs";
import { useTranslations } from "next-intl";
import { AccountSwitcherAccountItems } from "./AccountSwitcherAccountItems";
import { AccountSwitcherConnectItem } from "./AccountSwitcherConnectButton";
import { AccountSwitcherLogoutItem } from "./AccountSwitcherLogoutButton";
import { AccountSwitcherProfileItem } from "./AccountSwitcherProfileItem";
export function AccountSwitcherDropdown(t0) {
  const $ = _c(8);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccountSwitcherDropdownContent />;
    t2 = {
      Content: {
        className: "w-[240px] max-h-[600px] p-0 overflow-y-auto"
      }
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== rest) {
    t3 = <Dropdown align="end" content={t1} overrides={t2} side="bottom" trigger="hover" {...rest}>{children}</Dropdown>;
    $[5] = children;
    $[6] = rest;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function AccountSwitcherDropdownContent() {
  const $ = _c(15);
  const t = useTranslations("AccountSwitcherDropdown");
  const connections = useConnections();
  const {
    connect
  } = useConnect();
  const {
    disconnect
  } = useDisconnect();
  const {
    addToast,
    showErrorMessage
  } = useToasts();
  let handleSwitchAccount;
  if ($[0] !== addToast || $[1] !== connect || $[2] !== disconnect || $[3] !== showErrorMessage || $[4] !== t) {
    handleSwitchAccount = async (connector, address, isRetry) => {
      ;
      try {
        if (isRetry) {
          await disconnect(connector, {
            endSession: false
          });
        }
        await connect(connector, {
          address
        });
      } catch (t0) {
        const error = t0;
        if (error instanceof AccountNotConnectedError) {
          addToast({
            title: t("switchAccountInWallet", {
              walletName: connector.name
            }),
            icon: <SwapHoriz />,
            duration: 5000,
            dismissible: true
          });
          return;
        }
        if (!(isRetry || error instanceof WalletRejectedError)) {
          await handleSwitchAccount(connector, address, true);
          return;
        }
        captureException(error, {
          extra: {
            connector
          },
          tags: {
            source: "AccountSwitcherDropdown"
          }
        });
        showErrorMessage(t("failedToSwitchAccount"));
      }
    };
    $[0] = addToast;
    $[1] = connect;
    $[2] = disconnect;
    $[3] = showErrorMessage;
    $[4] = t;
    $[5] = handleSwitchAccount;
  } else {
    handleSwitchAccount = $[5];
  }
  let t0;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DropdownSeparator className="my-0" />;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const separator = t0;
  let t1;
  if ($[7] !== connections || $[8] !== handleSwitchAccount) {
    t1 = <AccountSwitcherAccountItems connections={connections} onSelect={handleSwitchAccount} />;
    $[7] = connections;
    $[8] = handleSwitchAccount;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AccountSwitcherConnectItem />;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccountSwitcherProfileItem />;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AccountSwitcherLogoutItem />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1) {
    t5 = <>{t1}{t2}{separator}{t3}{separator}{t4}</>;
    $[13] = t1;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}